<template>
    <div>
        <div class="modal fade" id="studyLog" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
            aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 id="exampleModalLabel">
                            <strong><i class="fa-solid fa-calendar-week"></i> Nhật ký truy cập của học viên</strong>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true" class="text-danger"><i
                                    class="fa-regular fa-circle-xmark"></i></span>
                        </button>
                    </div>
                    <div class="modal-body pb-2">
                        <div class="container-study-log">
                            <div>
                                <div class="study-log-title">
                                    Tổng thời gian học tập: <span class="text-success">{{
                                        this.$formatTime(study_total_time) }}</span>
                                </div>
                            </div>
                            <div>
                                <strong>Danh sách nhật ký truy cập:</strong>
                            </div>
                            <li v-for="(study_log, index) in study_logs" :key="index" class="study-log-item">
                                {{ this.$formatDateTime(study_log.created_at) }}
                            </li>
                            <div v-if="isLoading" class="d-flex justify-content-center container-loader">
                                <flower-spinner class="loading-component" :animation-duration="2000" :size="30"
                                    color="#06C755" />
                            </div>
                            <div class="d-flex justify-content-center mt-1">
                                <button type="button" @click="page += 1"
                                    class="view-more btn btn-outline-primary btn-sm">Xem
                                    thêm</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import UserRequest from '@/restful/UserRequest';
import { FlowerSpinner } from 'epic-spinners';

export default {
    name: "StudyLog",
    components: {
        FlowerSpinner,
    },
    props: {

    },

    data() {
        return {
            isLoading: false,
            study_logs: [],
            study_total_time: 0,
            page: 1,
            user_id: null,
        }
    },
    mounted() {
        this.$onEvent('eventGetStudyLog', (user_id) => {
            this.resetData();
            this.user_id = user_id;
            this.getStudyLog(user_id);
        });
    },
    methods: {
        resetData: function () {
            this.isLoading = false;
            this.study_logs = [];
            this.study_total_time = 0;
            this.page = 1;
        },
        getStudyLog: async function (user_id) {
            this.isLoading = true;
            try {
                const { data } = await UserRequest.get(`admin/management-user/study-log-of-user/${user_id}?page=${this.page}`);
                this.study_logs = [...this.study_logs, ...data.study_logs.data];
                this.study_total_time = data.study_total_time;
                this.isLoading = false;
            } catch (error) {
                this.isLoading = false;
                if (error.messages) this.$emitEvent('eventError', error.messages[0]);
            }
        },
    },
    watch: {
        page: {
            handler: function () {
                this.getStudyLog(this.user_id);
            },
            deep: true
        },
    }
}
</script>

<style scoped>
.modal-header .close {
    outline: none;
}

.modal-dialog {
    max-width: 80vw;
    margin: 10px auto;
}

.loading-component {
    margin: 50px 0px
}

.study-log-title {
    font-weight: bold;
}

.study-log-item {
    margin-left: 10px;
    list-style: square;
}

.view-more {
    border-radius: 20px;
}

.modal-body * {
    font-size: 16px;
}

@media screen and (max-width: 1200px) {
    .modal-body * {
        font-size: 15px;
    }
}

@media screen and (max-width: 992px) {
    .modal-body * {
        font-size: 14px;
    }
}

@media screen and (max-width: 768px) {
    .modal-body * {
        font-size: 13px;
    }
}

@media screen and (max-width: 576px) {
    .modal-body * {
        font-size: 12px;
    }
}

@media screen and (max-width: 425px) {
    .modal-body * {
        font-size: 11px;
    }
}

@media screen and (max-width: 375px) {
    .modal-body * {
        font-size: 10px;
    }
}
</style>